import { useMemo } from "react";
import RadarMap from "@/components/RadarMap";

const MAX_DIST_KM = 25;

export function RadarSurface({ nearby, coords, onDotClick, hangoutMembers = [], selfId }) {
  const dots = useMemo(() => {
    return nearby.slice(0, 20).map((u, i) => {
      const r = Math.min((u.distance_km / MAX_DIST_KM) * 45, 48); // % from center
      const angle = (i * 137.5) % 360;
      const x = 50 + r * Math.cos((angle * Math.PI) / 180);
      const y = 50 + r * Math.sin((angle * Math.PI) / 180);
      return { u, x, y };
    });
  }, [nearby]);

  return (
    <div className="relative w-full max-w-2xl mx-auto aspect-square bg-[#0A0B12] border border-white/5 rounded-3xl overflow-hidden">
      <RadarMap lat={coords?.lat} lng={coords?.lng} hangoutMembers={hangoutMembers} selfId={selfId} />
      {/* Concentric rings */}
      <div className="absolute inset-[6%] rounded-full border border-[#00E5FF]/40 pointer-events-none" />
      <div className="absolute inset-[20%] rounded-full border border-[#00E5FF]/40 pointer-events-none" />
      <div className="absolute inset-[34%] rounded-full border border-[#00E5FF]/40 pointer-events-none" />
      <div className="absolute inset-[48%] rounded-full border border-[#00E5FF]/40 pointer-events-none" />
      {/* Sweep */}
      <div className="absolute inset-[6%]">
        <div className="radar-sweep" />
      </div>
      {/* Pulses */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        {[0, 1, 2].map((i) => (
          <div key={i} className="radar-ring w-40 h-40" style={{ animationDelay: `${i * 1.1}s` }} />
        ))}
      </div>
      {/* Center = me */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <div className="w-5 h-5 rounded-full bg-[#00E5FF] glow-primary border-2 border-white/80" />
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-[9px] font-mono tracking-widest text-[#00E5FF]">YOU</div>
      </div>
      {/* Nearby dots */}
      {dots.map(({ u, x, y }) => (
        <button
          key={u.id}
          data-testid={`user-dot-${u.id}`}
          onClick={() => onDotClick(u)}
          className="absolute -translate-x-1/2 -translate-y-1/2 group"
          style={{ left: `${x}%`, top: `${y}%` }}
        >
          <div className="w-3 h-3 rounded-full bg-[#39FF14] glow-secondary dot-pulse group-hover:scale-150 transition-transform" />
          <div className="opacity-0 group-hover:opacity-100 absolute top-4 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] font-mono bg-black/70 border border-white/10 px-2 py-1 rounded text-white/90 transition-opacity">
            {u.display_name} · {u.distance_km}km
          </div>
        </button>
      ))}
    </div>
  );
}
